module.exports = "/call-frontend/img/撒点-蓝.02651251.png";